export const wordsSpace = [
    "Кос|мос",
    "Ра|кета",
    "Космо|навт",
    "Ска|фандр",
    "Зве|зда",
    "По|лет",
    "Эки|паж",
    "Пара|шют",
    "Кар|та",
    "Мар|шрут",
    "Топ|ливо",
    "Тю|бик",
    "Иллюми|натор",
    "Зем|ля"
  ];